import type {PreviewConfiguration} from 'schema/types';
import {AgentPrizes} from 'schemas/renderers/AgentPrizes';

export const agentPreviewConfig: PreviewConfiguration = {
  nameVariant: {
    excludeMainForm: true,
  },
  layout: {
    linkedValuesByRoles: true,
    groups: {
      info: {
        direction: 'horizontal',
      },
      internalComments: {
        direction: 'vertical',
      },
    },
  },
  partValueRenderers: {
    prizes: AgentPrizes,
  },
};
